import { MEDIA_LIBRARY_OPEN_EVENT } from "constants/TinyMCEEventConstants";
import { PluginRegistrationProps } from "components/TinyMCEPlugins/Plugins/RegisterPlugins";

const MediaLibraryPlugin = ({ editor }: PluginRegistrationProps) => {
  editor.ui.registry.addButton("medialibrary", {
    text: "Media Library",
    icon: "gallery",
    onAction: () => {
      if (editor.initialized) {
        editor.fire(MEDIA_LIBRARY_OPEN_EVENT);
      } else {
        editor.once("init", () => editor.fire(MEDIA_LIBRARY_OPEN_EVENT));
      }
    },
  });
};

export default MediaLibraryPlugin;
